import React, { useState } from 'react'
import { Layout } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { useToken, useWindowDimensions } from 'app/hooks'
import CompactLogo from './CompactLogo'
import CompactMenu from './CompactMenu'
import ProfileDropdown from './ProfileDropdown'
import NotificationBadges from './NotificationBadges'
import MobileMenuDrawer from './MobileMenuDrawer'
import VersionChecker from 'app/versionChecker'
import {
  CompactHeaderContainer,
  TopRow,
  BottomRow,
  LeftSection,
  CenterSection,
  RightSection,
  MobileMenuButton
} from './styles'

const { Header } = Layout

const CompactHeader: React.FC = () => {
  const { width } = useWindowDimensions()
  const { data: token } = useToken()
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false)

  const handleMobileMenuToggle = () => {
    setMobileMenuVisible(!mobileMenuVisible)
  }

  const isTwoRow = width <= 1400 // 1400px 이하에서만 두 줄

  return (
    <>
      <Header style={{
        padding: 0,
        height: isTwoRow ? '76px' : '40px', // 조건부 높이
        lineHeight: '40px'
      }}>
        <CompactHeaderContainer style={{ flexDirection: isTwoRow ? 'column' : 'row' }}>
          <VersionChecker />

          {isTwoRow ? (
            // 두 줄 레이아웃 (1400px 이하)
            <>
              <TopRow>
                <LeftSection>
                  <CompactLogo />
                  {token && width <= 1024 && (
                    <MobileMenuButton onClick={handleMobileMenuToggle}>
                      <MenuOutlined className="menu-icon" />
                    </MobileMenuButton>
                  )}
                </LeftSection>

                {token && width > 1024 && (
                  <CenterSection>
                    <CompactMenu />
                  </CenterSection>
                )}

                <RightSection>
                  <ProfileDropdown />
                </RightSection>
              </TopRow>

              {token && (
                <BottomRow>
                  <NotificationBadges />
                </BottomRow>
              )}
            </>
          ) : (
            // 한 줄 레이아웃 (1400px 초과)
            <>
              <LeftSection>
                <CompactLogo />
              </LeftSection>

              {token && (
                <CenterSection>
                  <CompactMenu />
                </CenterSection>
              )}

              <RightSection>
                {token && <NotificationBadges />}
                <ProfileDropdown />
              </RightSection>
            </>
          )}
        </CompactHeaderContainer>
      </Header>

      {token && (
        <MobileMenuDrawer
          visible={mobileMenuVisible}
          onClose={() => setMobileMenuVisible(false)}
        />
      )}
    </>
  )
}

export default React.memo(CompactHeader)